import React from 'react';
import { Tooltip } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

import DocsLink from '../../../docs/DocsLink';
import docsBookmarks from '../../../../constants/docs';
import NavigationSideCollapsedMenuItem from './MenuItem';

const NavigationSideCollapsedMenu = ({ onLogout, tenantPath, menuGroups }) => {
  const onClick = (e) => {
    e.preventDefault();
    onLogout();
  };

  return (
    <div className="side-navigation-menu collapsed">
      <div className="side-navigation-menu-item-group">
        <a href="." id="vizor-logo-link">
          <img alt="" src="/img/vizor-logo-32x32.png" height="32" width="32" />
        </a>
      </div>
      {Object.values(menuGroups).map((group, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className="side-navigation-menu-item-group">
          {group.map((item) => (
            <NavigationSideCollapsedMenuItem
              tenantPath={tenantPath}
              key={item.location}
              {...item}
            />
          ))}
        </div>
      ))}
      <div className="side-navigation-menu-item-group bottom">
        <Tooltip placement="right" title="Help">
          <div>
            <DocsLink
              scrolTo={docsBookmarks.headDocs}
              linkClassName="side-navigation-menu-item help-link"
              styleIcon={{ fontSize: 20, marginBottom: 5 }}
            />
          </div>
        </Tooltip>
        <Tooltip placement="right" title="Logout">
          <a
            className="side-navigation-menu-item logout-link"
            onClick={onClick}
            onKeyDown={() => {}}
          >
            <LogoutOutlined style={{ fontSize: 20 }} />
          </a>
        </Tooltip>
      </div>
    </div>
  );
};

export default NavigationSideCollapsedMenu;
